import { render, staticRenderFns } from "./PrivacyPolicyDialog.vue?vue&type=template&id=dee9b492&scoped=true&"
import script from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicyDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicyDialog.vue?vue&type=style&index=0&id=dee9b492&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee9b492",
  null
  
)

export default component.exports